/**
 * LoadingScreen.tsx
 *
 * Full-viewport loading state shown while Firebase determines the initial
 * auth state. This prevents a flash of the unauthenticated UI (login page)
 * while the SDK is initializing.
 *
 * Accessibility: uses role="status" with aria-live="polite" so screen readers
 * announce the loading state without interrupting ongoing narration.
 */
import { Box, CircularProgress, Typography } from '@mui/material';
import { COLOR } from '@/theme/tokens';

export function LoadingScreen(): JSX.Element {
  return (
    <Box
      component="main"
      role="status"
      aria-live="polite"
      aria-label="Loading PhiloFund"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: COLOR.gradient.brand,
        gap: 2,
      }}
    >
      <CircularProgress
        size={48}
        thickness={3}
        aria-hidden="true"
        sx={{ color: COLOR.primary.main }}
      />
      <Typography
        variant="body2"
        sx={{ color: COLOR.text.secondary, fontWeight: 500 }}
      >
        Loading…
      </Typography>
    </Box>
  );
}
